<template>
  <v-app>
    <TitleBar/>
    <!--<vue-recaptcha sitekey="Your key here"></vue-recaptcha>-->
    <router-view></router-view>
    <Footer/>
  </v-app>
</template>

<script>
import TitleBar from "@/components/layout/TitleBar";
import Footer from "@/components/layout/Footer";
// import VueRecaptcha from 'vue-recaptcha';
export default {
  name: 'App',
  components: {
    TitleBar,
    Footer,
    // VueRecaptcha
  },
};
</script>

<style>
.roundedBox {
  width: 410px;
  height: 410px;
}

body, div, h1, h2, h3, h4, h5, h6, p, span {
  font-family: 'Open Sans' , sans-serif !important;
  letter-spacing: 0px;
  color: #676767de;
  opacity: 1;
}

</style>
